import { enhanceCluster } from '@cast/shared-cluster-context-data-access';
import { Cluster } from '@cast/types';

export { enhanceCluster };

export const getClustersCacheUpdaterFn = (cluster: Cluster) => {
  return (data: Cluster[] | undefined): Cluster[] => {
    if (!data) {
      return [];
    }

    return data.map((_cluster) => {
      if (_cluster.id === cluster.id) {
        return {
          ..._cluster,
          status: cluster.status,
          displayStatus: cluster.displayStatus,
        };
      }
      return _cluster;
    });
  };
};
